module.exports = __webpack_public_path__ + "1801ed2b882f8a8ad45735de69561c94.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/foundation-hat.png
 ** module id = 475
 ** module chunks = 0
 **/